import type * as Blockly from 'blockly/core';
import { registerSdcardFile } from './helper/sdcard_helper';
import { resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['sdcard_clear'] = function (block: Blockly.Block): string {
        const board = resolveBoard(block);
        const filenameBase = block.getFieldValue('FILENAME') ?? 'data_1';
        const ext = block.getFieldValue('EXT') ?? 'txt';
        // ブルー(ESP32)のSDライブラリはVFS経由のため先頭スラッシュが必須
        const filename = `"${board === 'blue' ? '/' : ''}${filenameBase.toUpperCase()}.${ext.toUpperCase()}"`;

        const varName = registerSdcardFile(filename, 'APPEND', board);

        return (
            [
                `if (${varName}) ${varName}.close();`,
                `SD.remove(${filename});`,
                `${varName} = SD.open(${filename}, FILE_WRITE);`,
                `if (!${varName}) Serial.println("[SDカード] ファイルオープン失敗");`,
            ].join('\n') + '\n'
        );
    };
}
